import { render, staticRenderFns } from "./event_form.vue?vue&type=template&id=70a3da9b&scoped=true&"
import script from "./event_form.vue?vue&type=script&lang=js&"
export * from "./event_form.vue?vue&type=script&lang=js&"
import style0 from "./event_form.vue?vue&type=style&index=0&lang=css&"
import style1 from "./event_form.vue?vue&type=style&index=1&id=70a3da9b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70a3da9b",
  null
  
)

export default component.exports